export default "__VITE_ASSET__3e1c41c5__"